import { ProviderComposer } from "@design-lab/shared";
import { DtfChannelProvider } from "@design-lab/shared/hooks/useDtfChannel";
import { TransfersArtworksFormProvider } from "@design-lab/entities/transfers";
import { TransfersLabPage } from "@design-lab/pages/transfers-lab";
import { ArtworkFormProvider, ArtworkProvider } from "@design-lab/entities/artwork";
import { CompositionFormProvider } from "@design-lab/entities/composition";

export function TransfersLabRoute() {
  // Need Design Lab providers because Canvas component still uses them
  // (useTab, useArtworkForm, etc. are called from Canvas)
  const providers = [
    DtfChannelProvider,
    TransfersArtworksFormProvider,
    CompositionFormProvider,
    ArtworkFormProvider,
    ArtworkProvider
  ];

  return (
    <ProviderComposer providers={providers}>
      <TransfersLabPage />
    </ProviderComposer>
  );
}
